<template>
  <div class="Step">
    <VStack
      v-if="mobile"
      :pstyle="reverse && { 'flex-direction': 'column-reverse' }"
    >
      <slot />
    </VStack>
    <HStack v-else>
      <slot />
    </HStack>
  </div>
</template>

<script>
import { HStack, VStack } from '../../../layout/flexbox';

export default { components: { VStack, HStack }, props: ['mobile', 'reverse'] };
</script>

<style scoped>
.Step {
  max-width: 1200px;
  margin-top: 150px;
}
.Step::deep div {
  display: none;
}
</style>
